import apiClient from "../lib/api-client";

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  role?: string;
  roleName?: string | null;
  roleId?: string | null;
  roleRef?: {
    name: string;
  };
  tenantId: string;
  isActive: boolean;
  createdAt: string;
  tenant?: {
    id: string;
    name: string;
  };
  userStores?: Array<{
    store: {
      id: string;
      name: string;
    };
  }>;
}

export interface CreateUserDto {
  tenantId: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
  roleId: string;
  storeIds?: string[];
}

export interface UpdateUserDto extends Partial<CreateUserDto> {}

export interface UserListResponse {
  data: User[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const userService = {
  async getUsers(params?: {
    page?: number;
    limit?: number;
  }): Promise<UserListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append("page", params.page.toString());
    if (params?.limit) searchParams.append("limit", params.limit.toString());
    const response = await apiClient.get(`/users?${searchParams}`);
    return response.data;
  },

  async getUser(id: string): Promise<User> {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },

  async createUser(data: CreateUserDto): Promise<User> {
    const response = await apiClient.post("/users", data);
    return response.data;
  },

  async updateUser(id: string, data: UpdateUserDto): Promise<User> {
    const response = await apiClient.patch(`/users/${id}`, data);
    return response.data;
  },

  async deleteUser(id: string): Promise<void> {
    await apiClient.delete(`/users/${id}`);
  },
};
